import {createSlice, EntityState, PayloadAction} from '@reduxjs/toolkit';
import {MonthlyRate} from 'api/rates/rates.types';
import {
    getMonthlyRatesData,
    updateMonthlyRateData,
} from 'pages/rates/monthly/store/monthly-rates-actions';
import {monthlyRatesAdapter} from 'pages/rates/monthly/store/monthly-rates-adapters';

interface MonthlyRatesState extends EntityState<MonthlyRate> {
    isLoading: boolean;
}

const initialState: MonthlyRatesState = monthlyRatesAdapter.getInitialState({
    isLoading: true,
});

const monthlyRatesSlice = createSlice({
    name: 'monthlyRates',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getMonthlyRatesData.fulfilled,
                (state, action: PayloadAction<MonthlyRate[]>) => {
                    monthlyRatesAdapter.setAll(state, action.payload);
                    state.isLoading = false;
                }
            )
            .addCase(getMonthlyRatesData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getMonthlyRatesData.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(
                updateMonthlyRateData.fulfilled,
                (state, action: PayloadAction<MonthlyRate>) => {
                    monthlyRatesAdapter.upsertOne(state, action.payload);
                }
            );
    },
});

export default monthlyRatesSlice.reducer;
